<div class="db-enable-cdn-dialog">
  <p *ngIf="websiteUrl" class="website-title mb14">
    <i class="db-icon db-icon-ds-website-url"></i>
    <span>{{websiteUrl}}</span>
  </p>

  <h1 [innerHTML]="'text_enableCloudflareHeader' | dbText"></h1>
  <p class="mt5 mb14" *ngIf="server !== 'cloudflare'" [innerHTML]="'text_enableCloudflareContent' | dbText"></p>
  <p class="mt5 mb14" *ngIf="server === 'cloudflare'" [innerHTML]="'text_enableCloudflareContentCDN' | dbText"></p>
  <p class="mt5 mb25" *ngIf="server !== 'cloudflare'" [innerHTML]="'text_enableCloudflareSubHeader' | dbText"></p>
  <p class="mt5 mb25" *ngIf="server === 'cloudflare'" [innerHTML]="'text_enableCloudflareSubHeaderCDN' | dbText: {hostname: websiteUrl}"></p>

  <div>
    <form [formGroup]="serverIpForm">
      <div class="ds-input-wrap">
        <span class="ds-input-label">Original server IP</span>
        <p [ngClass]="{'ds-lazy-load': !!originalIpLoading || !dnsRecord}">
        <input formControlName="serverIp" type="text" class="ds-input"
               placeholder="{{serverIpForm?.controls?.serverIp?.value}}"
               [value]="serverIpForm?.controls?.serverIp?.value"
               [ngClass]="{'error': serverIpForm?.controls?.serverIp?.invalid && serverIpForm?.controls?.serverIp?.touched && !originalIpLoading}">
        </p>
        <span *ngIf="serverIpForm?.controls?.serverIp?.invalid && serverIpForm?.controls?.serverIp?.touched && !originalIpLoading" class="ds-input-error-msg">Invalid IPv4 address</span>
        <span class="ds-input-desc">Use your DNS management service to double check.</span>
      </div>
      <div class="ds-notification-error mb30" *ngIf="server === 'cloudflare'">
        <div>
          <i class="db-icon db-icon-ds-info-bg"></i>
          <p class="ds-notif" [innerHTML]="'Before proceeding, disable proxy for this domain from the DNS</br> management section of your Cloudflare account.'"></p>
        </div>
      </div>
      <div class="text-right">
        <a class="ds-btn-green ds-btn-l" [ngClass]="{'ds-btn-disabled': serverIpForm?.controls?.serverIp?.invalid || loading}"
           (click)="enable()">
          <span  *ngIf="!loading">Proceed</span>
          <span class="ds-spinner-circle"  *ngIf="loading"></span>
        </a>
      </div>
    </form>
  </div>

</div>
